export const environment = {
  production: true,
  identityMgmtApiUrl: '/identity-mgmt',
  licenseApiUrl: '/license',
  salesApiUrl: '/sales',
  remoteXpacApiUrl: '/remote-xpac',
  productionApiUrl: '/prod-tool',
  analyticsApiUrl: '/analytics',
  inventoryMgmtApiUrl: '/inventory-mgmt',
  xpacProxyUrl: '/xpac',
  issuer: '%%OPENID__AUTHORITY%%',
  aiConnectionString: '%%APPINSIGHTS__CONNECTIONSTRING%%',
  googleAnalyticsId: '%%GOOGLE__ANALYTICS__ID%%',
};
